define.alias("ember-basic-dropdown/components/basic-dropdown", "media/components/basic-dropdown");